import { Task } from '@lit/task';
import { LitElement, css, svg } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
/**
 * Image component
 */
@customElement('lua-svg-image')
export class LuaSvgImage extends LitElement {
  static override styles = [
    css`
      :host {
        display: block;
      }
    `,
  ];

  @property({ type: String })
  name: string;

  @property({ type: Number })
  width = 150;

  @property({ type: Number })
  height = 150;

  private loadImage = new Task(this, {
    task: async () => {
      if (!this.name) return;

      const image = await import(`./images/${this.name}.svg.ts`);
      return image.default({ width: this.width, height: this.height });
    },
    args: (): [] => [],
  });

  @state()
  private customSvg: Element;

  override connectedCallback(): void {
    super.connectedCallback();
    this.customSvg = this.children[0];
  }

  override render() {
    // TODO: error state placeholder
    // TODO: loading state placeholder
    return this.name
      ? this.loadImage.render({
          complete: (data) => svg`${unsafeSVG(data)}`,
        })
      : svg`${this.customSvg}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-svg-image': LuaSvgImage;
  }
}
